import { createContext, useContext } from 'react';
import { DEFAULT_DISPLAY_PREFERENCES } from '@/shared/types/preferences.types';
import type { DisplayPreferences } from '@/shared/types/preferences.types';

/**
 * Defaulted rather than left undefined so a component can be rendered in isolation — in a
 * test, or on a route with no session — without a provider and still format sensibly.
 */
export const PreferencesContext = createContext<DisplayPreferences>(DEFAULT_DISPLAY_PREFERENCES);

/** The display preferences in force for the current user. */
export function usePreferences(): DisplayPreferences {
  return useContext(PreferencesContext);
}
